import React, { useEffect } from 'react';
import { Gutter, Paragraph } from '@axiom/ui';

export const SideDrawerFallback = ({
  setExpanded,
}: {
  setExpanded: (expanded: boolean) => void;
}) => {
  useEffect(() => {
    setExpanded(false);
  }, [setExpanded]);

  return (
    <Gutter vertical="16px" horizontal="16px">
      <Paragraph name="NO_SIDE_DRAWER_CONTENT">
        Please select a record from the list.
      </Paragraph>
    </Gutter>
  );
};
